import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import Download from '@axetroy/react-download';
import { IMAGE_OBSERVATIONS } from '../../../../../../constants/app/inspection';
const closeSvg = <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" />
const ModalGetReport = ({ open = false, handleClose, handleOk, handleDate, date = {}, urlFile = { keyName: '' }, getUrl, isDisabled, statusReport, getReportFile = () => {} }) => {
	const url = (urlFile && urlFile.keyName && urlFile.keyName.length) ? urlFile.keyName : '';
	return(
		<Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true}>
			<div className="col-md-12 main-report">
				<span className="h2 mb10">Reporte de inspecciones</span>
				<div className="text-md--light m0 mt10">
                    Indica las fechas para descargar el reporte.
				</div>
				<div className="mt10">
                    <label for="phone" class="text-md--light text-left mb0">Fecha de inicio </label>
					<div className="col-md-9 ui-input-group include-icon input-left-0">
                        <input class="ui-form-control " placeholder="" id="dateStart" value={date.dateStart} type="date" onChange={handleDate.bind('dateStart')}/>
                        <span class="ui-input-group-addon"><span class="icon-calendar" /></span>
					</div>
                    <div className="col-md-9 ui-input-group include-icon input-left-0">
                        <label for="phone" class="text-md--light text-left">Fecha de fin </label>
                        <input class="ui-form-control " placeholder="" id="dateEnd" value={date.dateEnd} type="date" onChange={handleDate.bind('dateEnd')}/>
                        <span class="ui-input-group-addon"><span class="icon-calendar" /></span>
					</div>
					{
					(url && url.length)
						&&
						<button className="btn btn-outline-secondary w100p" onClick={getReportFile}>
							<a href={url} download={url} >Descargar</a>
						</button>
					}
					{
					!(url && url.length)
						&&
						<button className="btn btn-outline-secondary w100p" onClick={handleOk} disabled={isDisabled || statusReport === 1}>
							{statusReport === 1 ? 'Procesando...' : 'Procesar reporte'}
						</button>
					}
				</div>
			</div>
		</Modal>
	);
}
export default ModalGetReport;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/getReport/get-report-inspections.js